import vueMainInstance from "../main";

export default class User {
  constructor() {
    this.id = null;
    this.gross_in_currency = null;
    this.issue_date = null;
    this.net_in_currency = null;
    this.number = null;
    this.currency_symbol = null;
    this.sale_date = null;
    this.form_of_payment_name = null;
    this.is_cancelled = null;
    this.document_correction_id = null;
    this.left_to_pay = null;
    this.payments = [];
    this.invoiceItems = [];
  }

  load(invoiceId) {
    vueMainInstance.axios.get("invoice/get-invoice-details?id=" + invoiceId).then(resp => {
      this.id = resp.data.id;
      this.gross_in_currency = resp.data.gross_in_currency;
      this.issue_date = resp.data.issue_date;
      this.net_in_currency = resp.data.net_in_currency;
      this.number = resp.data.number;
      this.currency_symbol = resp.data.currency_symbol;
      this.sale_date = resp.data.sale_date;
      this.form_of_payment_name = resp.data.form_of_payment_name;
      this.is_cancelled = resp.data.is_cancelled;
      this.document_correction_id = resp.data.document_correction_id;
      this.left_to_pay = resp.data.left_to_pay;
      this.payments = resp.data.payments;
      this.invoiceItems = resp.data.invoiceItems;
      this.invoiceItems.sort(function(a, b) {
        if (a.serial_index < b.serial_index) {
          return -1;
        }
        if (a.serial_index > b.serial_index) {
          return 1;
        }
        return 0;
      });
      this.payments.sort(function(a, b) {
        if (a.payment_date < b.payment_date) {
          return -1;
        }
        if (a.payment_date > b.payment_date) {
          return 1;
        }
        return 0;
      });
    });
  }
}
